export default {"src":"/_next/static/media/clearSky.5755643a.svg","height":182,"width":182};